<template>
  
        <div class="actionButtons tright" v-if="params.data!=undefined">
            <template v-for="item in buttons" :key="item.classes">
                <button @click="btnClickedHandler(item.emit)" :title="item.emit" :class="item.classes" v-html="item.text" v-if="item.if==undefined || item.if(data)"></button>
            </template>
        </div>
</template>

<script>
    export default {
        data() {
            return {
                data:null,
                buttons:[],
                cellValue: null
            };
        },
        beforeMount() {
            this.buttons=this.params.colDef.buttons;
            this.cellValue = this.getValueToDisplay(this.params);
            this.data=this.params.data;
        },
        methods: {
            btnClickedHandler(emit) {
                this.params.clicked({...this.params,emit:emit});
            },
            getValueToDisplay(params) {
                return params.valueFormatted ? params.valueFormatted : params.value;
            }
        }
    }
</script>
